import React from 'react';

import Stack from '@mui/material/Stack';
import { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

type Props = {
  title: string;
  icon: React.ElementType;
  sx?: SxProps<Theme>;
};

const LabelWithIcon = ({ icon: Icon, title, sx }: Props) => {
  return (
    <Stack direction="row" spacing={2} alignItems="center" sx={sx}>
      <Icon fontSize="small" color="action" />
      <Typography variant="body1">{title}</Typography>
    </Stack>
  );
};

export default LabelWithIcon;
